import { render, staticRenderFns } from "./SelectStatus.vue?vue&type=template&id=200e8b1f"
import script from "./SelectStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectStatus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports